import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import App from './App'
import reportWebVitals from './reportWebVitals'

import MasterCSS from '@master/css'
import config from './master.css'
import 'material-icons/iconfont/material-icons.css'
import './index.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// 邪惡的Google Analytics
import ReactGA from 'react-ga4';
ReactGA.initialize('G-3CKJ7K640Z');
ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, });
const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA')
console.log('你是不是想壞壞▔▽▔▔▽▔▔▽▔')
// 目前有卡版本的問題 先拿掉
/*
serviceWorkerRegistration.register({
  onUpdate: registration => {
    const waitingServiceWorker = registration.waiting

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", event => {
        if (event.target.state === "activated") {
          window.location.reload()
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  }
})
*/
serviceWorkerRegistration.unregister();
export const css = new MasterCSS(config)